import React from 'react';

function Angola(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124202)">
        <mask
          id="mask0_800_124202"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124202)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#1D1D1D"
          />
          <mask
            id="mask1_800_124202"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124202)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H36V0H0Z"
              fill="#F50100"
            />
            <path
              d="M11.1747 5.89667L11.6548 4.49182C15.2551 5.46852 17.4255 7.18076 18.0361 9.62351C18.4411 11.244 18.257 12.6925 17.602 13.9824C17.1353 14.9014 16.5425 15.5874 15.6902 16.3597C14.2689 17.6476 11.9311 18.4694 9.82047 18.1209C8.3493 17.8781 6.99406 17.4194 5.75977 16.7455L6.62091 15.4934C7.68136 16.0723 8.84631 16.4666 10.1208 16.677C11.6449 16.9286 13.4518 16.2934 14.5149 15.3302C15.2431 14.6702 15.7292 14.1077 16.1003 13.377C16.6105 12.3724 16.7534 11.2477 16.4272 9.94272C15.9614 8.07902 14.2539 6.73203 11.1747 5.89667Z"
              fill="#FFEA42"
            />
            <g filter="url(#filter0_d_800_124202)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0771 9.46429L10.0089 10.1216L10.3857 9.02009L9.34871 8.3248L10.6498 8.30135L11.0771 7.21429L11.5043 8.30135L12.8054 8.3248L11.7684 9.02009L12.1453 10.1216L11.0771 9.46429Z"
                fill="#FCFF01"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0771 9.46429L10.0089 10.1216L10.3857 9.02009L9.34871 8.3248L10.6498 8.30135L11.0771 7.21429L11.5043 8.30135L12.8054 8.3248L11.7684 9.02009L12.1453 10.1216L11.0771 9.46429Z"
                fill="#FFEA42"
              />
            </g>
            <g filter="url(#filter1_d_800_124202)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.56567 9.85974C8.56567 9.85974 6.67133 12.3283 8.16299 13.2308C9.65465 14.1332 17.5423 17.9375 17.5423 17.9375C17.5423 17.9375 19.1721 17.9291 19.404 18.2373C19.6359 18.5455 20.1182 18.908 20.3216 18.908C20.5249 18.908 21.0501 18.5815 21.0501 18.5815C21.0501 18.5815 21.4595 18.2837 21.0501 17.9375C20.6407 17.5912 18.4767 16.4057 18.4767 16.4057C18.4767 16.4057 10.0303 11.6142 9.31202 11.1398C8.59379 10.6654 8.56567 9.85974 8.56567 9.85974Z"
                fill="#FCFF01"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.56567 9.85974C8.56567 9.85974 6.67133 12.3283 8.16299 13.2308C9.65465 14.1332 17.5423 17.9375 17.5423 17.9375C17.5423 17.9375 19.1721 17.9291 19.404 18.2373C19.6359 18.5455 20.1182 18.908 20.3216 18.908C20.5249 18.908 21.0501 18.5815 21.0501 18.5815C21.0501 18.5815 21.4595 18.2837 21.0501 17.9375C20.6407 17.5912 18.4767 16.4057 18.4767 16.4057C18.4767 16.4057 10.0303 11.6142 9.31202 11.1398C8.59379 10.6654 8.56567 9.85974 8.56567 9.85974Z"
                fill="#FFEA42"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.1758 4.07422L12.7373 4.95707L14.1753 5.51046L14.5831 4.62738L13.1758 4.07422ZM16.1151 5.48416L15.3233 6.14451L16.4038 7.15337L17.1673 6.48212L16.1151 5.48416ZM17.1968 8.13654L18.2092 7.7879L18.7642 9.06358L17.7734 9.4317L17.1968 8.13654ZM19.1689 10.6361L18.0837 10.6054L18.0452 11.9979L19.119 12.0032L19.1689 10.6361ZM17.828 13.1941L18.8212 13.5839L18.1989 14.8348L17.2055 14.4723L17.828 13.1941ZM17.2391 16.202L16.4962 15.4982L15.3612 16.4587L16.1164 17.1373L17.2391 16.202ZM14.2611 17.1671L14.6533 18.067L13.2182 18.5604L12.804 17.6797L14.2611 17.1671ZM11.4562 18.9214L11.4907 17.9568L9.92418 17.9226L9.91825 18.8771L11.4562 18.9214ZM8.58555 17.7283L8.14702 18.6111L6.73975 18.058L7.14752 17.1749L8.58555 17.7283Z"
              fill="#FFEA42"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_800_124202"
          x="9.34863"
          y="7.21429"
          width="3.45703"
          height="2.90735"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_800_124202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_800_124202"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_800_124202"
          x="7.59033"
          y="9.85974"
          width="13.6416"
          height="9.04822"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_800_124202"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_800_124202"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_800_124202">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Angola;
